import React from "react";
import Icon from "../Icon";
import Popup from "reactjs-popup";
import Router from "next/router";
import "reactjs-popup/dist/index.css";

import Button from "../Button";
import { useMediaQuery } from "react-responsive";

const NotificationDialog = ({
  open,
  des,
  onClose,
  navigation,
  casez,
  closeDialog,
  manualHandling,
  changeHandler,
}) => {
  const gotItHandler = () => {
    if (manualHandling) {
      changeHandler();
    } else {
      onClose();
    }
  };
  const isMobile = useMediaQuery({ maxWidth: "480px" });

  return (
    <div>
      <Popup
        modal
        open={open}
        closeOnDocumentClick={false}
        onClose={onClose}
        contentStyle={
          isMobile
            ? {
                backgroundColor: "#fff",
                borderRadius: "20px",
                marginLeft: "15px",
                marginRight: "15px",
                position: "relative",
                width: "450px",

                padding: "20px",
                alignItems: "center",
              }
            : {
                backgroundColor: "#fff",
                borderRadius: "20px",
                position: "relative",
                width: "450px",
                // height: "280px",
                padding: "30px",
                alignItems: "center",
              }
        }
      >
        <div
          className="overflow-y-scroll overflow-x-hidden h-fit "
          style={{ maxHeight: "70vh" }}
        >
          <div className=" flex flex-row justify-center items-center space-x-3">
            <Icon name="icon-info-dialogs" />
            <p className=" sm:text-lg xs:text-sm font-hkMedium text-inputColor">
              {des}
            </p>
          </div>
        </div>

        <Button
          title={casez ? "CONTINUE" : "Got it"}
          width="w-full"
          height="h-14"
          onButtonClick={gotItHandler}
        />

        <Icon
          name="icon-close-modal"
          onClick={casez ? closeDialog : gotItHandler}
        />
      </Popup>
    </div>
  );
};

export default NotificationDialog;
